import React, { useRef } from 'react'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'
import { ChartTooltip, XAxis, YAxis, Bar } from '../../components'
import { useBarChartHoverIndex, useBarSize, useMediaQuery } from '../../hooks'
import { formatGraphData, getAxisDomain } from '../../helpers'
import { GraphComponentProps } from '../../types'

const ExpensesAverageChart: React.FC<GraphComponentProps> = ({ data, graphHeight }) => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()
  const displayType = useMediaQuery()
  const [barSize, onResize] = useBarSize(-60, data?.length)

  const getMonthFormat = () => {
    switch (displayType) {
      case 'tablet':
        return 'three'
      default:
        return 'one'
    }
  }

  const formattedData = formatGraphData('expenses', 15, data, value => Math.round(Number(value)))
  const domain = getAxisDomain(formattedData, 'percent')

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight} onResize={onResize}>
      <BarChart
        ref={chartRef}
        data={formattedData}
        barCategoryGap={3}
        maxBarSize={barSize}
        margin={{ top: 0, left: -10, right: 0, bottom: 0 }}
        onMouseMove={handleBarMouseMove}
        onMouseLeave={handleBarMouseLeave}
      >
        <defs>
          <linearGradient id="color-exa" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FDC3C8" />
            <stop offset="1" stopColor="#FECDD1" />
          </linearGradient>
          <linearGradient id="colorHovered-exa" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FB606D" />
            <stop offset="1" stopColor="#FC7E88" />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: getMonthFormat(), chartType: 'bar', barSize })}
        {YAxis({ dataKey: 'expenses', unit: '€', domain })}
        <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
        {ChartTooltip({ cursor: false })}
        {Bar({
          dataKey: 'expenses',
          stroke: '#FB606D',
          unit: '€',
          hoveredIndex,
          borderRadius: 9,
          graphData: formattedData,
          color: 'url(#color-exa)',
          colorHovered: 'url(#colorHovered-exa'
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ExpensesAverageChart
